// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"bcfa3871b07f9445876f","477":"4d277fb6b87cb2234c8b"}[chunkId] + ".js";
};